import { render, staticRenderFns } from "./beneficiaryList.vue?vue&type=template&id=0820316c&scoped=true"
import script from "./beneficiaryList.vue?vue&type=script&lang=js"
export * from "./beneficiaryList.vue?vue&type=script&lang=js"
import style0 from "./beneficiaryList.vue?vue&type=style&index=0&id=0820316c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820316c",
  null
  
)

export default component.exports